import { render } from "./ProductButton.vue?vue&type=template&id=5feeb078"
import script from "./ProductButton.vue?vue&type=script&lang=js"
export * from "./ProductButton.vue?vue&type=script&lang=js"

import "./ProductButton.vue?vue&type=style&index=0&id=5feeb078&lang=css"

import exportComponent from "C:\\Users\\MAX\\Documents\\Repositorios\\gem_tpv_pwa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__